import { useEffect, useState, useRef } from "react";
import { motion, useInView, animate } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

export default function SoldStrip() {
  const { lang } = useLang();
  const [count, setCount] = useState(0);
  const [display, setDisplay] = useState(0);
  const ref = useRef(null);
  const inView = useInView(ref, { margin: "-120px" });

  useEffect(() => {
    // Solo il conteggio: page/limit minimo, filtro server-side, valore da header.
    api.get("/cars", { params: { page: 1, limit: 1, status: "sold" } })
      .then((r) => setCount(Number(r.headers?.["x-total-count"] || 0)))
      .catch(() => setCount(0));
  }, []);

  // Conteggio in crescita: parte da 0 e sale fino al totale reale delle vendute.
  // Si riattiva ogni volta che la sezione entra in vista.
  useEffect(() => {
    if (!inView) return;
    setDisplay(0);
    const controls = animate(0, count, {
      duration: 1.1,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, count]);

  return (
    <section className="px-6 sm:px-10 lg:px-14 max-w-[1600px] mx-auto" data-testid="sold-strip" ref={ref}>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8 }}
        className="border border-white/10 p-8 sm:p-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6"
      >
        <div className="flex items-center gap-6 sm:gap-8">
          <div
            className="font-racing font-black text-6xl sm:text-8xl leading-none text-white"
            data-testid="sold-count"
          >
            {String(display).padStart(2, "0")}
          </div>
          <div>
            <div className="label-eyebrow text-neutral-500">{lang === "en" ? "Cars" : "Vetture"}</div>
            <div className="label-eyebrow text-neutral-400">{lang === "en" ? "Sold" : "Vendute"}</div>
          </div>
        </div>

        <Link
          to="/vendute"
          className="group inline-flex items-center gap-2 label-eyebrow text-neutral-400 hover:text-white transition-colors self-start sm:self-auto"
          data-testid="sold-strip-all"
        >
          {lang === "en" ? "View the archive" : "Vedi l'archivio"}
          <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform duration-300" />
        </Link>
      </motion.div>
    </section>
  );
}
